"use strict";

import { AppDispatcher } from 'Dispatcher';
import { FormEditConstants } from "Constants/Forms/FormEditConstants";
export function formEditInitialize(options) {
  AppDispatcher.asyncDispatch({
    actionType: FormEditConstants.FORM_EDIT_INITIALIZE,
    options: options
  });
}
export function formEditSubmited(_ref) {
  var formData = _ref.formData,
      formUUID = _ref.formUUID,
      mode = _ref.mode;
  AppDispatcher.dispatch({
    actionType: FormEditConstants.FORM_EDIT_SUBMITED,
    formData: formData,
    formUUID: formUUID,
    //parent formUUID
    mode: mode
  });
}
export function formEditUpdate(_ref2) {
  var nextData = _ref2.nextData,
      nextView = _ref2.nextView,
      formEvents = _ref2.formEvents,
      formUUID = _ref2.formUUID,
      props = _ref2.props,
      errorMessage = _ref2.errorMessage,
      tables = _ref2.tables;
  AppDispatcher.asyncDispatch({
    actionType: FormEditConstants.FORM_EDIT_UPDATE,
    nextData: nextData,
    nextView: nextView,
    formEvents: formEvents,
    formUUID: formUUID,
    errorMessage: errorMessage,
    tables: tables,
    props: props
  });
}
export function formEditNestedFormLoaded(_ref3) {
  var UUID = _ref3.UUID,
      parentFormID = _ref3.parentFormID;
  AppDispatcher.asyncDispatch({
    actionType: FormEditConstants.FORM_EDIT_NESTED_FORM_LOADED,
    UUID: UUID,
    parentFormID: parentFormID
  });
}
export function destroyForm(formUUID) {
  AppDispatcher.asyncDispatch({
    actionType: FormEditConstants.FORM_EDIT_DESTROY,
    formUUID: formUUID
  });
}
export function formEditUpdateSubForm(formEditUUID, table) {
  AppDispatcher.asyncDispatch({
    actionType: FormEditConstants.FORM_EDIT_UPDATE_SUBFORM,
    formUUID: formEditUUID,
    table: table
  });
}